import React, {Component} from 'react';
import {
  Text,
  View,
  Animated,
  Easing,
  TouchableOpacity,
  Image,
  Dimensions,
} from 'react-native';
import PropTypes from 'prop-types';
import SettingStyleSheet from '../StyleSheets/SettingStyleSheet';
import CommonStyleSheet from '../StyleSheets/CommonStyleSheet';
import closeIcon from '../assets/closeBlackIcon.png';
import closeWhiteIcon from '../assets/closeWhiteIcon.png';
import {ThemeContext} from '../HelperClasses/ThemeContext';

const windowWidth = Dimensions.get('window').width;
const configViewRightMargin = -420;

export default class SidePanView extends Component {
  static contextType = ThemeContext;

  constructor(props) {
    super(props);
    this.state = {
      rightPosition: new Animated.Value(configViewRightMargin),
      addViewBool: this.props.showSidepanView,
    };
  }
  static propTypes = {
    showSidepanView: PropTypes.bool,
    customView: PropTypes.any,
    title: PropTypes.string,
    headerAction: PropTypes.node,
    dissmissView: PropTypes.func,
    customWidth: PropTypes.any,
    fullHeight: PropTypes.bool,
  };
  stopAnimation = () => {
    this.setState({addViewBool: false});
    this.props.dissmissView();
    Animated.timing(this.state.rightPosition, {
      toValue: this.props.customWidth ? windowWidth / 2 : configViewRightMargin,
      duration: 300,
      easing: Easing.linear,
    }).start();
  };
  mooveRL() {
    Animated.timing(this.state.rightPosition, {
      toValue: 0,
      duration: 300,
      easing: Easing.linear,
    }).start();
  }

  renderSidePanView = () => {
    const themeColors = this.context?.colors;
    const closeButtonIcon = this.context?.isDark ? closeWhiteIcon : closeIcon;
    var views = [];
    var showSideView = false;
    var title = '';
    if (this.state.addViewBool == true) {
      showSideView = true;
      title = this.props.title;
      this.mooveRL();
      views.push(
        <View key="content" style={{flex: 1, minHeight: 0}}>
          {this.props.customView}
        </View>,
      );
    }
    return (
      <View
        style={[
          SettingStyleSheet.blackContainerViewStyle,
          {
            display: showSideView ? 'flex' : 'none',
            position: 'fixed',
            top: 60,
            right: 0,
            bottom: 0,
            left: 0,
            width: '100vw',
            height: 'calc(100vh - 60px)',
            zIndex: 100000,
            justifyContent: 'flex-end',
          },
        ]}
        className="shared-sidepan-overlay">
        <TouchableOpacity
          style={{flex: 1, width: undefined, height: '100%'}}
          className="shared-sidepan-backdrop"
          onPress={() => this.stopAnimation()}
        />
        <View
          style={[
            {height: '100%', maxWidth: '100%', overflow: 'hidden'},
            this.props.customWidth ? {width: '50%'} : {width: 420},
          ]}
          className="shared-sidepan-shell">
          <Animated.View
            style={[
              this.props.customWidth
                ? [
                    SettingStyleSheet.customAnimationViewStyle,
                    {height: '100%', backgroundColor: themeColors?.screenBackground},
                  ]
                : [
                    SettingStyleSheet.animationViewStyle,
                    {height: '100%', backgroundColor: themeColors?.screenBackground},
                  ],
            ]}
            className="shared-sidepan-panel">
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                zIndex: 101,
                flexShrink: 0,
              }}
              className="shared-sidepan-header">
              <TouchableOpacity
                style={{marginRight: 10}}
                onPress={() => this.stopAnimation()}>
                <Image
                  source={closeButtonIcon}
                  style={SettingStyleSheet.closeBtnStyle}
                />
              </TouchableOpacity>
              <Text
                style={[
                  CommonStyleSheet.plainTextStyle,
                  {color: themeColors?.primaryText},
                ]}>
                {title}
              </Text>
              {this.props.headerAction ? (
                <View style={{marginLeft: 'auto'}}>{this.props.headerAction}</View>
              ) : null}
            </View>
            <View
              style={{
                height: 'calc(100vh - 120px)',
                width: '100%',
                minWidth: 0,
                overflow: 'scroll',
              }}
              className="shared-sidepan-content">
              {views}
            </View>
          </Animated.View>
        </View>
      </View>
    );
  };

  render() {
    return <View>{this.renderSidePanView()}</View>;
  }
}
